"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfBulkShiftAcceptDto = instanceOfBulkShiftAcceptDto;
exports.BulkShiftAcceptDtoFromJSON = BulkShiftAcceptDtoFromJSON;
exports.BulkShiftAcceptDtoFromJSONTyped = BulkShiftAcceptDtoFromJSONTyped;
exports.BulkShiftAcceptDtoToJSON = BulkShiftAcceptDtoToJSON;
exports.BulkShiftAcceptDtoToJSONTyped = BulkShiftAcceptDtoToJSONTyped;
/**
 * Check if a given object implements the BulkShiftAcceptDto interface.
 */
function instanceOfBulkShiftAcceptDto(value) {
    if (!('shiftIds' in value) || value['shiftIds'] === undefined)
        return false;
    if (!('nurseProfileId' in value) || value['nurseProfileId'] === undefined)
        return false;
    return true;
}
function BulkShiftAcceptDtoFromJSON(json) {
    return BulkShiftAcceptDtoFromJSONTyped(json, false);
}
function BulkShiftAcceptDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'shiftIds': json['shiftIds'],
        'nurseProfileId': json['nurseProfileId'],
    };
}
function BulkShiftAcceptDtoToJSON(json) {
    return BulkShiftAcceptDtoToJSONTyped(json, false);
}
function BulkShiftAcceptDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'shiftIds': value['shiftIds'],
        'nurseProfileId': value['nurseProfileId'],
    };
}
//# sourceMappingURL=BulkShiftAcceptDto.js.map